module.exports = __webpack_public_path__ + "static/media/diktat-0.20da8c02.mp3";